import React from 'react';
import { Moon, Sun, Wifi, WifiOff, Menu } from 'lucide-react';

export const Navbar = ({ isDarkMode, toggleTheme, status }) => (
  <nav className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-white/70 dark:bg-black/50 border-b border-gray-200 dark:border-white/10 transition-colors duration-300">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between h-16">
        {/* 로고 영역 */}
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold shadow-lg shadow-blue-500/30">O</div>
          <span className="text-xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400">OortCloud</span>
        </div>
        
        {/* 데스크탑 메뉴 */}
        <div className="hidden md:flex items-center space-x-8">
          {['Dashboard', 'Market', 'Wallet', 'Analytics'].map((item) => (
            <button key={item} className="text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">{item}</button>
          ))}
        </div>

        {/* 우측 컨트롤 (와이파이, 테마 버튼) */}
        <div className="flex items-center gap-4">
          <div className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold ${
            status === 'Connected' ? 'bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-400' : 'bg-red-100 text-red-700 dark:bg-red-500/20 dark:text-red-400'
          }`}>
            {status === 'Connected' ? <Wifi size={12} /> : <WifiOff size={12} />}
            {status}
          </div>
          <button onClick={toggleTheme} className="p-2 rounded-full bg-gray-100 dark:bg-white/10 hover:bg-gray-200 dark:hover:bg-white/20 transition-all text-gray-700 dark:text-yellow-300">
            {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <button className="md:hidden p-2 text-gray-600 dark:text-gray-300"><Menu size={20} /></button>
        </div>
      </div>
    </div>
  </nav>
);